import React from 'react'
import { config } from '../../../../config';
import './PaymentStatus.scss';

export const PaymentStatus = ({status, paymentId}) => {
    return (
        <div className="payment-status-component">
              <div className={`payment-status-component__container ${status}`}>
                <Status title={config.statusTitles[status]} icon={`${status}.svg`} />
                {paymentId && <span>Your payment ID: {paymentId}</span>}
              </div>
        </div>
    )
}

const Status = ({icon = "success-icon.png", title}) => {
    return (
        <>
            <img src={require(`../../../../images/${icon}`)} alt={icon} />
            <h2>{title}</h2>
        </>
    )
}

export default PaymentStatus;
